<script>
import { FormModel } from '@/components/global/form';
import { scrollToError } from '../../utilities/helpers';

export default {
    name: 'CcPoliticalVulnerabilityInfoForm',

    props: {
        initialData: null,
    },

    data() {
        return {
            loading: false,
            model: null,
            additionalVulnerableIndex: -1,
        };
    },

    created() {
        this.model = new FormModel(this.initialData);
    },

    computed: {
        isSelfPoliticallyVulnerable() {
            return this.model.$.politically_vulnerable_relations.find(item => item.type === 1);
        },

        canRemoveRelation() {
            return this.model.$.is_politically_vulnerable && this.model.$.politically_vulnerable_relations.length > 1;
        },
    },

    watch: {
        'model.$.is_politically_vulnerable'(value) {
            if (value) {
                if (!this.model.$.politically_vulnerable_relations.length) {
                    this.model.$.politically_vulnerable_relations = [
                        {
                            id: this.additionalVulnerableIndex--,
                            type: null,
                            name: null,
                            last_name: null,
                            info: null,
                            country_id: null,
                            institution: null,
                            political_vulnerabilities: [],
                        },
                    ];
                }
            } else {
                this.model.$.politically_vulnerable_relations = [];
            }
        },
    },

    methods: {
        async submit() {
            if (this.loading) {
                return;
            }
            this.loading = true;

            try {
                const response = await this.$http.post('/registracija/informacija-apie-politini-pazeidziamuma', this.model.$);
                window.location = response.data.data.redirect;
            } catch (e) {
                this.model.$e.updateFromResponse(e);
                scrollToError();
                this.$sentyReporting.report(e);
            }

            this.loading = false;
        },

        addRelation() {
            this.model.$.politically_vulnerable_relations.push({
                id: this.additionalVulnerableIndex--,
                type: null,
                name: null,
                last_name: null,
                info: null,
                country_id: null,
                institution: null,
                political_vulnerabilities: [],
            });
        },

        removeRelation(relation) {
            const index = this.model.$.politically_vulnerable_relations.indexOf(relation);

            if (index > 0) {
                this.model.$.politically_vulnerable_relations = this.model.$.politically_vulnerable_relations.filter(item => item !== relation);
            }
        },

        vulnerabilityChange(relation) {
            if (relation.type === 1 || relation.type === '1') {
                return;
            }

            if (!relation.political_vulnerabilities.length) {
                return;
            }

            relation.political_vulnerabilities = relation.political_vulnerabilities.slice(relation.political_vulnerabilities.length - 1, relation.political_vulnerabilities.length);
        },

        typeChange(relation) {
            if (relation.type === 1 || relation.type === '1') {
                return;
            }

            relation.political_vulnerabilities = [];
        },
    },
};
</script>
